import React from "react";

export default function HowItWorksVidoes() {
  return (
    <div>
      <div class="works_wrapper float_left">
        <div class="work_banner_wrapper">
          <img src="images/work_banner.jpg" alt="img" />
        </div>
        <div class="howwork_banner_wrapper">
          <div class="vedio_link_wrapper">
            {/* <a
              class="test-popup-link button"
              rel="external"
              href="https://www.youtube.com/embed/ryzOXAO0Ss0"
              title="title"
            >
              <i class="fa fa-play"></i>
            </a> */}
            <div class="work_content_wrap">
              <h1>How It Works</h1>
              <ul class="work_checklist_wrapper">
                <li>
                  <a href="#">
                    <i class="fas fa-dollar-sign"></i>get deposit
                  </a>
                </li>
                <li>
                  <a href="#">
                    <i class="far fa-money-bill-alt"></i> utilize money
                  </a>
                </li>
                <li>
                  <a href="#">
                    <i class="fas fa-plus"></i> give interest
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
